import { UnitLocation } from "@covertree/new-business-graphql";

export const isManufacturedHomePark = (unitLocation: UnitLocation) =>
  [
    UnitLocation.LargeManufacturedHome,
    UnitLocation.SmallManufacturedHome,
  ].includes(unitLocation);
